import { combineReducers } from 'redux';
import userReducer from './auth';
import categoryReducer from './category';
import localClassificationReducer from './localClassification';
import locaisReducer from './locais';
import sideMenuReducer from './sideMenu';

export default combineReducers({
  user: userReducer,
  category: categoryReducer,
  localClassification: localClassificationReducer,
  locais: locaisReducer,
  sideMenuReducer,
});
